import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Green_Btn_With_Icon.css'

const Green_Btn_With_Icon = (props) => {

    
    return (
        <button className="Green_Btn_With_Icon" onClick={props?.onClick} type={props.type||'button'}>
            {props?.leftIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.leftIcon} className='left_icon' />
                </div>
            )}

            <p className='btn_text'>{props?.btnText}</p>

            {props?.rightIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.rightIcon} className='right_icon' />
                </div>
            )}
        </button>
    )
}

export default Green_Btn_With_Icon
